'use client';
import { Surface } from '@payments-checkout/shared/components';
import { Divider, Text } from '@stone-payments/jade';
import { Fragment } from 'react';
import { CheckoutItem } from './detailCheckoutItem';

type DetailCheckoutProps = {
  items: Array<{
    name: string;
    description: string;
    unit: number;
    unitDescription: string;
    value: string;
  }>;
  title?: string;
  removeBorderRadiusBottom?: boolean;
};

export function DetailCheckout({ items, title, removeBorderRadiusBottom }: DetailCheckoutProps) {
  return (
    <Surface
      backgroundColor="surface"
      data-testid="checkout-details"
      className='max-h-[400px] overflow-y-auto'
      style={removeBorderRadiusBottom ? { borderBottomLeftRadius: '0', borderBottomRightRadius: '0' } : undefined}
    >
      {title && (
        <div className="pt-jade-100 pb-jade-100">
          <Text variant="heading-xsmall" color="high">
            {title}
          </Text>
        </div>
      )}
      {items.map((item, index) => (
        <Fragment key={`${item.name}-${index}`}>
          <CheckoutItem {...item} isLast={index === items.length - 1} />
          {index !== items.length - 1 && items.length > 1 && <Divider />}
        </Fragment>
      ))}
    </Surface>
  );
}
